<template>
    <div class="dvgraficobarra">
        <v-chart :options="options"/>
    </div>
</template>
<style>
</style>
<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'

import 'echarts/theme/dark'

export default {
    name : "cmpgraficobar",
    components: {
        'v-chart': ECharts
    },
    props:[		
        'titulo',
        'agrupamento',
		'series'
    ],
    data () {
        return {
            options : {
                title: {
                    text: ''
                },
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    show : false,
                    left: '0',
                    right: '0',
                    bottom: '0',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            show  : false,
                            title : 'Salvar gráfico'                            
                        }
                    }
                },
                xAxis: {
                    data: [],
                    show: true 
                },
                yAxis: {
                    type: 'value',
                    show : true
                },
                series: 
                    {
                        data: [],
                        type: 'bar',
                        showBackground: false,
                        color: "#007bff"         
                    }
            }
        }
    },
    mounted: function () {         
    },    
    computed:{
    },
    watch:{
        series(){
            this.options.title.text     			= this.titulo;
            this.options.xAxis.data 			    = this.agrupamento;
			this.options.series.data                = this.series;			
        }
    }    
}
</script>